import Div from "@jumbo/shared/Div/Div";
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {useEffect, useState} from "react";
import {get} from "../../common/network";
import PdfFormPreview from "../../components/common/preview-form/PdfFormPreview";
import PreviewFormsSelected from "../../components/common/preview-forms-selected/PreviewFormsSelected";
import "./PreviewForms.css";


const PreviewFavoriteForm = () => {
    const [selectedForm, setSelectedForm] = useState("");
    const [formList, setFormList] = useState([]);
    const [formData, setFormData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const queryParams = new URLSearchParams(window.location.search);
    const sharedIds = queryParams.getAll("id");

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await get(`docgen/forms/favorite`);
                const filteredForms = response.data.filter(form => sharedIds.includes(String(form.id)));
                setFormList(filteredForms);
                setSelectedForm(filteredForms.length > 0 ? filteredForms[0].id : "");
            } catch (error) {
            }
        };
        fetchData();
    }, []);

    //#region for useEffect to fetch details of a Form by form id
    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const response = await get(`docgen/forms/${selectedForm}`);
                setFormData(response);
            } catch (error) {
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, [selectedForm]);

    const onSaveAndNext = async () => {
        const currentIndex = formList.findIndex((item) => item.id === selectedForm);

        if (currentIndex !== -1) {
            const nextIndex = (currentIndex + 1) % formList.length; // Loop back to 0 if at the end
            setSelectedForm(formList[nextIndex].id);
        } else if (formList.length > 0) {
            setSelectedForm(formList[0].id); // Go to the first form
        }
    };

    const backHandler = () => {
        const currentIndex = formList.findIndex((item) => item.id === selectedForm);

        if (currentIndex !== -1) {
            const previousIndex =
                (currentIndex - 1 + formList.length) % formList.length; // Loop to the end if at the beginning
            setSelectedForm(formList[previousIndex].id);
        } else if (formList.length > 0) {
            setSelectedForm(formList[formList.length - 1].id); // Go to the last form
        }
    };

    return (
        <div className="page-content-wrapper">
            <Box className="w-100">
                <header className="section-heading">
                    <div></div>
                    <div>
                        <section className="top-actions-section preview-form">
                            <div className="buttons-group">
                                <ul>
                                    <li className="ms-2">
                                        <Button type="button" onClick={backHandler}>
                                            <div className="icon-area">
                                                <ArrowBackIosNewOutlinedIcon/>
                                            </div>
                                            <p className="text-area">Back</p>
                                        </Button>
                                    </li>
                                    <li>
                                        <Button type="button" onClick={onSaveAndNext}>
                                            <div className="icon-area">
                                                <ArrowForwardIosOutlinedIcon/>
                                            </div>
                                            <p className="text-area">Next</p>
                                        </Button>
                                    </li>
                                </ul>
                            </div>
                        </section>
                    </div>
                </header>
                <div>
                    <div className="preview-form-layout">
                        <Div
                            sx={{
                                width: "240px !important",
                                backgroundColor: "#eee !important"
                            }}
                            className="selected-forms-area"
                        >
                            {selectedForm ? (
                                <PreviewFormsSelected
                                    upperSectionProps={{
                                        title: "Form Code",
                                        selectedItems: formList,
                                        selectedItem: selectedForm,
                                        setColor: "green-chip"
                                    }}
                                    setSelectedForm={setSelectedForm}
                                />
                            ) : ("")}
                        </Div>
                        {isLoading ? (
                            <Div
                                sx={{
                                    width: "100%",
                                    height: "100%",
                                    minHeight: "60vh",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",

                                    ".btn-loader-icon": {
                                        width: "60px",
                                        height: "60px",
                                        border: "5px solid gray",
                                        borderColor: "transparent gray gray gray",
                                        borderRadius: "50%",
                                        animation: "rotate .5s linear infinite"
                                    }
                                }}
                            >
                                <div className="btn-loader-icon"></div>
                            </Div>
                        ) : (
                            <div className="syncfusion-form-area">
                                <div className="container">
                                    <PdfFormPreview formData={formData}/>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Box>
        </div>
    );
};


export default PreviewFavoriteForm;